// Finding rows (Defender XDR, Fortinet) are not control assessments and never count toward
// coverage. Mirrors the backend SecurityControlComplianceAdapter.IsScoringRow.
export function isScoringControl(control) {
    return control.source !== "DefenderXDR" && control.source !== "FortinetConnector";
}
